import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const AvailabilityFormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
`;

export const DayContainer = styled.div`
  max-height: 44px;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  ${media.md`
    width: 50%;
  `}
`;
